export default __webpack_public_path__ + "static/media/you-did-it.dbd5dbd7.png";